/* =====================================================================
   mb-product.js — Baseline 2.6.1 custom product section
   Handles: desktop thumbnail scroll-spy + click, mobile dot indicators,
   quantity stepper. All desktop logic gated on ≥1024px.
   ===================================================================== */
(function () {
  'use strict';
 
  const DESKTOP_BP = 1024;
 
  function init(section) {
    /* ── Sticky text height = viewport height (desktop only) ── */
    const stickyText = section.querySelector('.mb-sticky-text');
    if (stickyText) {
      const syncHeight = () => {
        stickyText.style.height = window.innerWidth >= DESKTOP_BP
          ? window.innerHeight + 'px'
          : '';
      };
      syncHeight();
      window.addEventListener('resize', syncHeight, { passive: true });
      window.addEventListener('orientationchange', syncHeight, { passive: true });
    }
 
    /* ── Desktop thumbnails ── */
    const thumbs = Array.from(section.querySelectorAll('.mb-thumb'));
    const items  = Array.from(section.querySelectorAll('.mb-media-item'));
 
    function headerH() {
      const cs = getComputedStyle(document.documentElement);
      return parseFloat(cs.getPropertyValue('--header-height')) || 66;
    }
 
    function setThumbActive(idx) {
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }
 
    thumbs.forEach(btn => {
      btn.addEventListener('click', () => {
        if (window.innerWidth < DESKTOP_BP) return;
        const idx = parseInt(btn.dataset.index, 10);
        const target = items[idx];
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - headerH() - 20;
        window.scrollTo({ top, behavior: 'smooth' });
        setThumbActive(idx);
      });
    });
 
    /* IntersectionObserver scroll-spy → update active thumbnail */
    if ('IntersectionObserver' in window && thumbs.length && items.length) {
      const io = new IntersectionObserver(entries => {
        if (window.innerWidth < DESKTOP_BP) return;
        let best = null;
        entries.forEach(en => {
          if (en.isIntersecting) {
            if (!best || en.boundingClientRect.top < best.boundingClientRect.top) best = en;
          }
        });
        if (best) {
          const idx = parseInt(best.target.dataset.index, 10);
          if (!Number.isNaN(idx)) setThumbActive(idx);
        }
      }, {
        root: null,
        rootMargin: `-${headerH() + 20}px 0px -55% 0px`,
        threshold: 0
      });
      items.forEach(it => io.observe(it));
    }
 
    /* ── Mobile dot indicators ── */
    const mobImages = section.querySelector('.mb-mobile-images');
    const dotStrip  = section.querySelector('.mb-dot-strip');
 
    if (mobImages && dotStrip) {
      const mobItems = Array.from(mobImages.querySelectorAll('.mb-mobile-img-item'));
 
      /* Build dots dynamically from image count */
      mobItems.forEach((_, i) => {
        const d = document.createElement('span');
        d.className = 'mb-dot' + (i === 0 ? ' is-active' : '');
        dotStrip.appendChild(d);
      });
      const dots = Array.from(dotStrip.querySelectorAll('.mb-dot'));
 
      function setDotActive(idx) {
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
 
      if ('IntersectionObserver' in window && mobItems.length) {
        const mobIO = new IntersectionObserver(entries => {
          entries.forEach(en => {
            if (en.isIntersecting) {
              const idx = mobItems.indexOf(en.target);
              if (idx !== -1) setDotActive(idx);
            }
          });
        }, { root: mobImages, threshold: 0.5 });
        mobItems.forEach(it => mobIO.observe(it));
      }
    }
 
    /* ── Quantity stepper ── */
    const qtyInput = section.querySelector('.mb-quantity-input input[type="number"]');
    const minusBtn = section.querySelector('.mb-qty-btn[name="minus"]');
    const plusBtn  = section.querySelector('.mb-qty-btn[name="plus"]');
 
    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', () => {
        if (+qtyInput.value > 1) qtyInput.value = +qtyInput.value - 1;
      });
      plusBtn.addEventListener('click', () => {
        qtyInput.value = +qtyInput.value + 1;
      });
    }
  }
 
  /* Boot on all product sections present at load */
  function boot() {
    document.querySelectorAll('.mb-product-section').forEach(init);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
 
  /* Re-init when Shopify reloads the section in the theme editor */
  document.addEventListener('shopify:section:load', e => {
    const sec = e.target.querySelector('.mb-product-section');
    if (sec) init(sec);
  });
 
})();